import { refItemHistory } from "@tc/drizzle-v2"
import { eq } from "drizzle-orm"
import {
  SQSClient,
  SendMessageCommand,
  MessageAttributeValue,
} from "@aws-sdk/client-sqs"
import { DbTransaction } from "@tc/middy-decorators"
import { ItemHistoryDoc } from "../types/reference-data"
import { searchBuilderLog } from "../utils/logger"

const sqs_client = new SQSClient({})
const queue_url = process.env["ITEM_HISTORY_QUEUE_URL"]

export const getRefItemHistoryData = async (
  tx: DbTransaction,
  id: string,
): Promise<ItemHistoryDoc | undefined> => {
  const [row] = await tx
    .select({
      id: refItemHistory.id,
      itemId: refItemHistory.itemId,
      operation: refItemHistory.operation,
      listCode: refItemHistory.listCode,
      itemCode: refItemHistory.itemCode,
      itemName: refItemHistory.itemName,
      unCode: refItemHistory.unCode,
      effectiveStartDate: refItemHistory.effectiveStartDate,
      effectiveEndDate: refItemHistory.effectiveEndDate,
      updatedAt: refItemHistory.updatedAt,
      updatedBy: refItemHistory.updatedBy,
    })
    .from(refItemHistory)
    .where(eq(refItemHistory.id, parseInt(id)))

  if (!row) {
    console.error(`RefItemHistory with id ${id} not found`)
    return
  }

  const refItemHistoryDoc: ItemHistoryDoc = {
    id: row.id.toString(),
    item_id: row.itemId,
    operation: row.operation,
    list_code: row.listCode,
    item_code: row.itemCode,
    item_name: row.itemName,
    un_code: row.unCode,
    effective_start_date: new Date(row.effectiveStartDate).getTime(),
    effective_end_date: row.effectiveEndDate
      ? new Date(row.effectiveEndDate).getTime()
      : null,
    updated_at: row.updatedAt.getTime(),
    updated_by: row.updatedBy,
  }

  searchBuilderLog.debug({
    document: refItemHistoryDoc,
  })

  return refItemHistoryDoc
}

export const saveRefItemHistoryToSearch = async (
  tx: DbTransaction,
  id: string,
  collectionName: string,
  options?: { returnDoc?: boolean },
): Promise<void> => {
  const doc = await getRefItemHistoryData(tx, id)

  if (!doc || Object.keys(doc).length === 0) {
    console.error(`Failed to prepare document for id: ${id}`)
    return
  }

  if (options?.returnDoc) return doc as never

  const attributes: Record<string, MessageAttributeValue> = {
    collection: {
      StringValue: collectionName,
      DataType: "String",
    },
  }

  const command = new SendMessageCommand({
    QueueUrl: queue_url,
    MessageBody: JSON.stringify(doc),
    MessageAttributes: attributes,
  })

  await sqs_client.send(command)
}
